import {
  ListItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useAuthStore } from "hooks/useAuthStore";
import { IconContext } from "react-icons";
import { BiEdit } from "react-icons/bi";
import { RiLockPasswordFill } from "react-icons/ri";
import { ModalChangePassword } from "./components/modalChangePassword";

export const ChangePassword = () => {
  const { changeOpenModalPassword } = useAuthStore();
  return (
    <>
      <ListItem
        secondaryAction={
          <IconButton onClick={() => changeOpenModalPassword(true)}>
            <BiEdit />
          </IconButton>
        }
      >
        <ListItemIcon>
          <IconContext.Provider value={{ className: "text-4xl" }}>
            <RiLockPasswordFill />
          </IconContext.Provider>
        </ListItemIcon>
        <ListItemText
          primary="Cambiar la contraseña"
          secondary="Puede cambiar la contraseña de su cuenta utilizando esta ventana de diálogo."
        />
      </ListItem>
      <ModalChangePassword />
    </>
  );
};
